export const TZ = "Europe/Belgrade";

export const STATUS = {
  free: {
    key: "free",
    label: "Free",
    bg: "#FFFFFF",
    border: "#E7E5E4",
    text: "#1C1917",
    badgeBg: "#F5F5F4",
    badgeText: "#57534E",
    dot: "#A8A29E",
  },
  taken: {
    key: "taken",
    label: "Taken",
    bg: "#0284C7",
    border: "#0284C7",
    text: "#FFFFFF",
    badgeBg: "#E0F2FE",
    badgeText: "#0369A1",
    dot: "#0284C7",
  },
  sold_multiple: {
    key: "sold_multiple",
    label: "Sold Multiple Times",
    bg: "#EA580C",
    border: "#EA580C",
    text: "#FFFFFF",
    badgeBg: "#FFEDD5",
    badgeText: "#C2410C",
    dot: "#EA580C",
  },
};

export const statusMeta = (s) => STATUS[s] || STATUS.free;

export const STATUS_FILTERS = [
  { key: "all", label: "All" },
  { key: "free", label: "Free" },
  { key: "taken", label: "Taken" },
  { key: "sold_multiple", label: "Sold Multiple" },
];

export function initials(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function timeLabel(iso, withSeconds = false) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      ...(withSeconds ? { second: "2-digit" } : {}),
      timeZone: TZ,
    });
  } catch {
    return "";
  }
}

export function dateLabel(dateStr) {
  if (!dateStr) return "";
  try {
    return new Date(dateStr + "T12:00:00").toLocaleDateString("en-GB", {
      weekday: "short",
      day: "2-digit",
      month: "short",
      year: "numeric",
      timeZone: TZ,
    });
  } catch {
    return dateStr;
  }
}
